import { Sparkles, Gift, Handshake } from "lucide-react";
import { cn } from "@/lib/utils";

export const COLLAB_TYPES = ["Influencer", "Giveaway", "Ongoing"];
export const COLLAB_TYPE_LABEL = { Influencer: "Influencer", Giveaway: "Giveaway", Ongoing: "Ongoing Collab" };
const BASE = ["Prospect", "In Discussion", "Confirmed/Scheduled"];
export const COLLAB_STATUSES = {
  Influencer: [...BASE, "In Progress", "Completed", "Declined", "Cancelled"],
  Giveaway: [...BASE, "In Progress", "Completed", "Declined", "Cancelled"],
  Ongoing: [...BASE, "Active", "Ended", "Declined", "Cancelled"],
};
export const ALL_COLLAB_STATUSES = [...BASE, "In Progress", "Active", "Completed", "Ended", "Declined", "Cancelled"];
export const PLATFORMS = ["Instagram", "TikTok", "YouTube", "Facebook", "Blog", "Podcast", "Other"];

const ICON = { Influencer: Sparkles, Giveaway: Gift, Ongoing: Handshake };
const TYPE_CLS = { Influencer: "bg-pink-50 text-pink-600", Giveaway: "bg-amber-50 text-amber-600", Ongoing: "bg-teal-50 text-teal-600" };
const STATUS_CLS = {
  Prospect: "bg-slate-100 text-slate-600", "In Discussion": "bg-sky-50 text-sky-700", "Confirmed/Scheduled": "bg-indigo-50 text-indigo-700",
  "In Progress": "bg-emerald-50 text-emerald-700", Active: "bg-emerald-50 text-emerald-700", Completed: "bg-slate-100 text-slate-500",
  Ended: "bg-slate-100 text-slate-500", Declined: "bg-red-50 text-red-600", Cancelled: "bg-red-50 text-red-600",
};

export function CollabIcon({ type, className = "h-4 w-4" }) {
  const Icon = ICON[type] || Handshake;
  return <Icon className={className} />;
}
export const collabTypeCls = (t) => TYPE_CLS[t] || TYPE_CLS.Ongoing;

export function CollabStatusPill({ status }) {
  return <span className={cn("inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold", STATUS_CLS[status] || STATUS_CLS.Prospect)} data-testid="collab-status-pill">{status}</span>;
}

const fmt = (k) => (k ? new Date(`${k.slice(0, 10)}T00:00:00`).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }) : "");
export function collabDates(c) {
  if (c.collab_type === "Ongoing" && c.ongoing) return c.start_date ? `From ${fmt(c.start_date)} · Ongoing` : "Ongoing";
  if (c.start_date && c.end_date && c.end_date !== c.start_date) return `${fmt(c.start_date)} – ${fmt(c.end_date)}`;
  return fmt(c.start_date || c.end_date) || "No dates";
}
